import * as React from "react";
const IconConnections = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx={10.9863}
      cy={17.4924}
      rx={7}
      ry={3.5}
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <circle
      cx={10.9863}
      cy={6.99243}
      r={4}
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.031 10.242C15.709 10.7409 15.315 11.1889 14.8636 11.5715C15.2181 11.6826 15.5952 11.7424 15.9863 11.7424C18.0574 11.7424 19.7363 10.0635 19.7363 7.99243C19.7363 6.03665 18.2391 4.43057 16.3283 4.25781C16.5945 4.77678 16.7873 5.3396 16.893 5.93258C17.6841 6.2813 18.2363 7.07237 18.2363 7.99243C18.2363 9.22013 17.253 10.2182 16.031 10.242Z"
      fill={props.color || "#1C1C2C"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9859 17.5487C19.9758 18.1629 19.801 18.753 19.4871 19.3033C19.8555 19.2019 20.2006 19.0845 20.5174 18.9525C21.1146 18.7036 21.6468 18.3883 22.0412 17.9998C22.4382 17.6087 22.7363 17.0988 22.7363 16.4924C22.7363 15.8859 22.4382 15.3761 22.0412 14.985C21.6468 14.5965 21.1146 14.2811 20.5174 14.0323C19.4948 13.6062 18.1769 13.3318 16.7357 13.2607C17.7379 13.7698 18.5564 14.4094 19.1214 15.1367C19.4191 15.2198 19.6934 15.314 19.9405 15.4169C20.4292 15.6205 20.7756 15.8439 20.9885 16.0536C21.1987 16.2606 21.2363 16.4085 21.2363 16.4924C21.2363 16.5763 21.1987 16.7241 20.9885 16.9312C20.7823 17.1343 20.4507 17.3503 19.9859 17.5487Z"
      fill={props.color || "#1C1C2C"}
    />
  </svg>
);
export default IconConnections;
